import React from "react";
import "./styles.css";

export default () => (
    <div className="toolbar-container">
        <div className="login-button" data-netlify-identity-button></div>
    </div>
);
